import { render, staticRenderFns } from "./adjuntos_list.vue?vue&type=template&id=26b6a633&scoped=true&lang=pug&"
import script from "./adjuntos_list.vue?vue&type=script&lang=js&"
export * from "./adjuntos_list.vue?vue&type=script&lang=js&"
import style0 from "./adjuntos_list.vue?vue&type=style&index=0&id=26b6a633&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b6a633",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VContainer,VDialog,VSpacer})
